import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil } from 'lodash';
import { Settings, UrlBuilder } from '../../core';
import { UserStorage } from '../../user';

@Component({
    selector: 'sm-header',
    template: require('./sm-header.component.html'),
    styles: [require('./sm-header.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SMHeaderComponent {

    public userName: Observable<string>;
    public emulatedUserFullName: Observable<string>;
    public isSampleTrackingEnabled$: Observable<boolean>;

    constructor(userStorage: UserStorage, settings: Settings, private urlBuilder : UrlBuilder) {
        const currentUser = userStorage.currentUser;

        this.userName = currentUser.pipe(map(user => user.metadata.originalUserFullName));

        if (!isNil(settings.emulatedUserId)) {
            this.emulatedUserFullName = currentUser.pipe(map(user => user.metadata.fullName));
        }

    }

    public navigateToHome() {
        this.urlBuilder.esa().navigate();
    }
}